import { PostApiIntroducerPortalIntroducerRequestBody } from '@iwoca/lapi-client/introducer_portal';
import { isValidUKPhoneNumber } from 'utils/phoneNumberHelper';
import * as yup from 'yup';
import { TPermissions } from '../cells/PermissionsCell.types';

type TTitle = PostApiIntroducerPortalIntroducerRequestBody['data']['title'];

export const TITLE_OPTIONS: TTitle[] = ['Mr', 'Ms', 'Mrs', 'Miss'];

export type TAddUserFormValues = {
  title: TTitle;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  permissions: TPermissions;
};

export const addUserSchema = yup.object({
  title: yup.string().required('Title is required'),
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  email: yup
    .string()
    .email('Please use a valid email format')
    .required('Email address is required'),
  phone_number: yup
    .string()
    .required('Phone number is required')
    .test(
      'is-valid-phone-number',
      'Please use a valid phone number format',
      isValidUKPhoneNumber,
    ),
});
